// "Edit FBO information" modal of a charter booking: departure and arrival FBO.
import type { FormInstance } from 'antd';
import { Form, Input, Modal, Typography } from 'antd';

import { LIMITS } from '../../data/limits';
import type { CharterBookingUpdate } from './charterBookingUpdate';

const { Title } = Typography;

export function FboModal({
  fboForm,
  fboOpen,
  setFboOpen,
  submitFbo,
  submitGuard,
  saveMut,
}: {
  fboForm: FormInstance;
  fboOpen: boolean;
  setFboOpen: (open: boolean) => void;
  submitFbo: () => void;
  submitGuard: { busy: boolean };
  saveMut: { isPending: boolean; mutate: (body: CharterBookingUpdate) => void };
}) {
  return (
    <Modal
      title="Edit FBO information"
      open={fboOpen}
      onCancel={() => setFboOpen(false)}
      onOk={submitFbo}
      confirmLoading={submitGuard.busy || saveMut.isPending}
      okText="Save"
      destroyOnClose
    >
      <Form form={fboForm} layout="vertical">
        <Title level={5}>Departure</Title>
        <Form.Item name="depName" label="FBO name"><Input maxLength={LIMITS.name} /></Form.Item>
        <Form.Item name="depAddress" label="FBO address"><Input maxLength={LIMITS.text} /></Form.Item>
        <Form.Item name="depPhone" label="FBO phone number"><Input maxLength={LIMITS.phone} /></Form.Item>
        <Title level={5}>Arrival</Title>
        <Form.Item name="arrName" label="FBO name"><Input maxLength={LIMITS.name} /></Form.Item>
        <Form.Item name="arrAddress" label="FBO address"><Input maxLength={LIMITS.text} /></Form.Item>
        <Form.Item name="arrPhone" label="FBO phone number"><Input maxLength={LIMITS.phone} /></Form.Item>
      </Form>
    </Modal>
  );
}
